import React, { createContext, useReducer, useEffect } from "react";

const initialState = {
  cartItems: JSON.parse(localStorage.getItem("cartItems")) || [],
};

const cartReducer = (state, action) => {
  let updatedCart;
  switch (action.type) {
    case "ADD_TO_CART":
      const existingItem = state.cartItems.find(
        (item) => item.id === action.payload.id
      );
      if (!existingItem) {
        updatedCart = [...state.cartItems, { ...action.payload }];
      } else {
        updatedCart = state.cartItems; 
      }
      break;

    case "REMOVE_FROM_CART":
      updatedCart = state.cartItems.filter((item) => item.id !== action.payload.id);
      break;

    default:
      return state;
  }

  localStorage.setItem("cartItems", JSON.stringify(updatedCart));
  return { ...state, cartItems: updatedCart };
};

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
  }, [state.cartItems]);

  return (
    <CartContext.Provider
      value={{
        cartState: state,
        cartDispatch: dispatch,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => React.useContext(CartContext);
